var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dashboard-stat2 bordered collapsible",
      attrs: { id: "tileId" },
    },
    [
      _c("div", { staticClass: "display" }, [
        _vm.expandable
          ? _c(
              "a",
              {
                staticClass: "btn-icon-only btn-default btn-expand",
                staticStyle: {
                  height: "27px",
                  "text-align": "center",
                  padding: "2px 6px",
                  width: "27px",
                },
                on: {
                  click: function ($event) {
                    return _vm.TileClick()
                  },
                },
              },
              [
                _c("i", {
                  staticClass: "fa fa-chevron-down rotate",
                  staticStyle: { color: "gray", cursor: "pointer" },
                  attrs: { id: "btExpand_" + _vm.title },
                }),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "number middle-bar children",
            class: _vm.align == "right" ? "right-align" : "",
            staticStyle: { display: "table", width: "100%" },
          },
          [
            _c("small", { style: { color: _vm.colorTitle } }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _vm._v(" "),
            _c("div", {}, [
              _vm.expandable
                ? _c("a", {
                    staticClass: "accordion-toggle collapsed",
                    attrs: {
                      id: "collapse" + _vm.title,
                      "data-toggle": "collapse",
                      "data-parent": "#accordion1",
                      href: "#collapse_" + _vm.title,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "panel-collapse collapse",
                  class: _vm.expanded ? "in" : "",
                  attrs: { id: "collapse_" + _vm.title },
                },
                [
                  _c("transition", { attrs: { name: "fade" } }, [
                    _vm.showFullData
                      ? _c(
                          "div",
                          { staticClass: "childrens" },
                          _vm._l(_vm.additionalDescValue, function (descValue) {
                            return _c("div", { key: descValue.description }, [
                              _c(
                                "small",
                                { style: { color: _vm.colorDescription } },
                                [_vm._v(_vm._s(descValue.description))]
                              ),
                              _vm._v(" "),
                              _c(
                                "h3",
                                {
                                  class: _vm.colorTheme,
                                  staticStyle: { "font-size": "25px" },
                                  style: { color: _vm.colorValueField },
                                },
                                [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.getValueField(descValue.value))
                                    ),
                                  ]),
                                ]
                              ),
                            ])
                          }),
                          0
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.description
              ? _c("div", [
                  _c("small", { style: { color: _vm.colorDescription } }, [
                    _vm._v(_vm._s(_vm.description)),
                  ]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", [
              _c("div", [
                _c(
                  "h3",
                  {
                    class: _vm.colorTheme,
                    staticStyle: { "font-size": "25px" },
                    style: { color: _vm.colorValueField },
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.getValueField(_vm.valueField))),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              !_vm.visibilityPerc
                ? _c("div", { style: { color: _vm.colorPerc() } }, [
                    _c("i", { class: _vm.iconPerc() }),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-weight": "600",
                          "margin-left": "2px",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(Math.round(Math.abs(_vm.percentage), 2)) + "%"
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          "font-size": "10px",
                          color: "gray",
                          "font-weight": "600",
                        },
                      },
                      [_vm._v("(em relação ao mês anterior)")]
                    ),
                  ])
                : _vm._e(),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "right-bar" }, [
          _vm.iconMain
            ? _c("div", [
                _c("div", { staticClass: "icon" }, [
                  _c("i", {
                    class: [_vm.iconMain, _vm.colorTheme],
                    style: { color: _vm.colorIconMain },
                  }),
                ]),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.link
            ? _c(
                "a",
                {
                  staticClass:
                    "btn btn-circle btn-icon-only btn-default bottom-align",
                  staticStyle: {
                    height: "27px",
                    padding: "2px 6px 2px",
                    width: "27px",
                    "margin-top": "17px",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.AbrirDetalhes()
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-search",
                    style: { color: _vm.colorIconSearch },
                  }),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }